import React, { useState, useEffect } from "react";
import { loginRequest } from "../../authConfig";
import { Container, Typography, TextField, Button, CardContent } from "@material-ui/core";
import { useMsal } from "@azure/msal-react";
import logo from "../../assets/img/logo.svg";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useStateValue } from "../../contexto/store";
import { obtenerUsuarioActual, obtenerUsuarioAzure } from "actions/usuarioAction";
import "fontsource-roboto";
import "./CajaLogin.css";

const CajaLogin = () => {
  const navigate = useNavigate();
  const { instance } = useMsal(); // instancia para azure
  const [usuario, setUsuario] = React.useState({ email: "" });
  const [showLoginWithEmail] = useState(process.env.REACT_APP_SHOW_SSO_LOGIN === 'false');
  const [{ sesionUsuario }, dispatch] = useStateValue(); //var global de estado usuario y dispatch(contexto)
  // flag variable de estado local, para saber si el request fue hecho o no al server
  const [iniciaApp, setIniciaApp] = useState(false);
  // flag para controlar el proceso de autenticación y evitar múltiples clicks
  const [isAuthenticating, setIsAuthenticating] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  // Manejar el redirect de vuelta de Azure AD
  useEffect(() => {
    const handleRedirect = async () => {
      try {
        // Verificar si el usuario cerró sesión manualmente
        const manualLogout = localStorage.getItem("manualLogout");
        console.log({ manualLogout })

        if (manualLogout === "true") {
          console.log('ℹ️ Sesión cerrada manualmente. No se realizará auto-login desde Azure SSO.');
          return; // No hacer auto-login
        }

        const response = await instance.handleRedirectPromise();
        if (response) {
          console.log('✅ Usuario autenticado desde Azure redirect:', response.account?.username);
          console.log('📋 Token recibido:', response.accessToken ? 'Sí' : 'No');

          // Activar estado de autenticación para bloquear el botón
          setIsAuthenticating(true);

          // Enviar token al backend
          const payload = { token: response.accessToken };
          LoginWithAzure(payload);
        }
      } catch (error) {
        console.error('❌ Error manejando redirect de Azure:', error);
        if (error.errorCode !== 'user_cancelled') {
          alert('Error al completar autenticación: ' + error.message);
        }
      }
    };

    handleRedirect();
  }, [instance]);

  const ingresarValoresMemoria = (e) => {
    const { name, value } = e.target;
    setUsuario((anterior) => ({
      ...anterior,
      [name]: value,
    }));
  };

  // Función helper para redirigir al usuario según sus menús permitidos
  const getRedirectUrl = (menus) => {
    if (!menus || menus.length === 0) {
      return "auth/perfil"; // Fallback por defecto
    }

    // Buscar un menú que contenga 'perfil' en la URL (página de inicio)
    const perfilMenu = menus.find(m => m.url && m.url.toLowerCase().includes('perfil'));

    if (perfilMenu) {
      // Remover el '/' inicial si existe para que funcione con navigate
      return perfilMenu.url.startsWith('/') ? perfilMenu.url.substring(1) : perfilMenu.url;
    }

    // Si no encuentra perfil, usar la primera URL disponible
    if (menus[0] && menus[0].url) {
      return menus[0].url.startsWith('/') ? menus[0].url.substring(1) : menus[0].url;
    }

    return "auth/perfil"; // Fallback final
  };

  // Submit Datos a ApiLogin
  const onSubmit = () => {
    const payload = { email: usuario.email };
    LoginWithMail(payload);
  };

  // Funcion que llama a Api Login
  const LoginWithMail = async (payload) => {
    if (!iniciaApp) {
      await obtenerUsuarioActual(dispatch, payload)
        .then(response => {
          setIniciaApp(true);
          sessionStorage.setItem(
            "usuario",
            JSON.stringify(response.data)
          );
          const dataUsuario =  response.data;

          // Obtener URL de redirección basada en los menús del usuario
          const menus = response.data.result.menus || [];
          const redirectUrl = getRedirectUrl(menus);
          return navigate(redirectUrl);
        })
        .catch((error) => {
          alert("Usuario no esta autorizado para acceder al Sistema ", error);
          localStorage.clear();
          sessionStorage.clear();
          setIniciaApp(false);
        });
    }
  };


  // Launch Azure AD Login con redirect
  const handleAzure = () => {
    console.log('🚀 Iniciando login con Azure AD (redirect)...');

    // Activar estado de autenticación para bloquear el botón
    setIsAuthenticating(true);

    // Limpiar flag de logout manual cuando el usuario inicia sesión explícitamente
    localStorage.removeItem("manualLogout");

    instance
      .loginRedirect(loginRequest)
      .catch((error) => {
        console.error('❌ Error en loginRedirect:', error);
        // No mostrar alerta si el usuario canceló
        if (error.errorCode !== 'user_cancelled') {
          alert('Error al autenticar con Azure: ' + error.message);
        }
        // Desactivar estado de autenticación en caso de error
        setIsAuthenticating(false);
      });
  };

  // Llama a endpoint Validacion usuario Azure
  const LoginWithAzure = async (payload) => {
    if (!iniciaApp) {
      await obtenerUsuarioAzure(dispatch, payload)
        .then((response) => {
          setIniciaApp(true);
          window.sessionStorage.setItem(
            "usuario",
            JSON.stringify(response.data)
          );

          // Obtener URL de redirección basada en los menús del usuario
          const menus = response.data.result.menus || [];
          const redirectUrl = getRedirectUrl(menus);
          return navigate(redirectUrl);
        })
        .catch((error) => {
          alert("Usuario no esta autorizado para acceder al Sistema ", error);
          localStorage.clear();
          sessionStorage.clear();
          setIniciaApp(false);
          setIsAuthenticating(false); // Desactivar estado de autenticación en caso de error
        });
    }
  };
  return (
    <>
            <div className="root">
              <CardContent className="shadowBox">
              <div className="divlogo">
                <img src={logo} alt="imagen" className="logo" />
              </div>
                
                <CardContent className="card_content">
                  <Container>
                    <Typography align={'center'} className="txt_iniciarSesion">
                      Iniciar Sesión
                    </Typography>
                    <form
                      onSubmit={handleSubmit(onSubmit)}
                      className="formulario">
                      {showLoginWithEmail && <TextField
                        fullWidth
                        autoFocus
                        name="email"
                        color="primary"
                        margin="normal"
                        label="Correo electrónico BHP"
                        variant="outlined"
                        value={usuario.email}
                        onChange={ingresarValoresMemoria}
                      /> }
                      {errors.email && <span>{errors.email.message}</span>}
                      <Container className="contenedor-cajalogin-buttons">
                        { showLoginWithEmail &&
                          <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            className="cajalogin-button-ingresar"
                           >
                            <Typography className="ingresar_btn">
                              Ingresar
                            </Typography>
                          </Button>
                        }
                        {!showLoginWithEmail &&
                        <Button
                            variant="contained"
                            color="primary"
                             className="cajalogin-button-ingresar"
                            onClick={() => handleAzure()}
                            disabled={isAuthenticating || iniciaApp}
                          >
                            <Typography
                              className="ingresar_btn"
                            >
                              {isAuthenticating ? 'Autenticando...' : 'Ingresar Azure'}
                            </Typography>
                          </Button>
                          }
                        <Button href="https://sspr.bhp.com/">
                          <Typography
                            className="txt_recordar">
                            ¿Olvidaste tu contraseña?
                          </Typography>
                        </Button>
                        
                      </Container>
                      <Typography className="txt_version">Versión {process.env.REACT_APP_VERSION || '0'} – {process.env.REACT_APP_COMMIT_HASH || '0'} </Typography>    
                    </form>
                    
                  </Container>
                  
                </CardContent>
              </CardContent>
            </div>
    </>
  );
};

export default CajaLogin;

export const IdTokenClaims = (props) => {
  return (
    <div id="token-div">
      <p>
        <strong>Audience: </strong> {props.idTokenClaims.aud}
      </p>
      <p>
        <strong>Issuer: </strong> {props.idTokenClaims.iss}
      </p>
      <p>
        <strong>OID: </strong> {props.idTokenClaims.oid}
      </p>
      <p>
        <strong>UPN: </strong> {props.idTokenClaims.preferred_username}
      </p>
    </div>
  );
};